export const getStatusName = ({ order }) => {
    return order.status === 0 && !order.has_failed_payment
        ? 'En attente de paiement'
        : order.status === 0 && order.has_failed_payment
        ? 'Paiement échoué'
        : order.getStatusTitle()
}
